import React, { useCallback, useMemo, useState } from "react";
import { useDashboardEditorContext } from "../../../../hook/context/editor";
import t from "../../../../../../../i18n";
import InputV2 from "@ui/Input/InputV2";
import { css } from "@linaria/core";
import type { BlockPlotModelT } from "../../../../schema/block/plot";
import type { BlockDiagramModelT } from "../../../../schema/block/diagram";
import type { BlockImageModelT } from "../../../../schema/block/image";

export function BlockDataTitle({
  block,
}: {
  block: BlockPlotModelT | BlockDiagramModelT | BlockImageModelT;
}) {
  const editor = useDashboardEditorContext();
  const [value, setValue] = useState(() =>
    typeof block.data === "string" ? block.data : block.data.title,
  );

  const update = useCallback(
    (title: string) => {
      if (!block) return;
      setValue(title);

      if (block.kind === "IMAGE") {
        void editor?.updateBlock({
          ...block,
          data: title,
        });
      }

      if (block.kind === "PLOT" || block.kind === "DIAGRAM") {
        void editor?.updateBlock({
          ...block,
          data: { ...block.data, title },
        });
      }
    },
    [block, editor, setValue],
  );

  const label = useMemo(() => {
    if (block.kind === "DIAGRAM") return t("project.dashboard.editor.gui.section.title.diagram");
    if (block.kind === "IMAGE") return t("project.dashboard.editor.gui.section.title.image");
    if (block.kind === "PLOT") return t("project.dashboard.editor.gui.section.title.plot");
    return "";
  }, [block.kind]);

  if (!block) return null;

  return (
    <InputV2
      label={label}
      className={blockDataTitle}
      value={value}
      onChange={e => update(e.target.value)}
      maxLength={100}
    />
  );
}

const blockDataTitle = css`
  width: 100%;
`;
